import { en } from './en';

const i18n = {
  en,
};

export default i18n;
